<template>
  <div class="blog-article-page">
    <Meta property="og:description" :content="article?.shortDescription" />
    <Meta property="og:image" :content="article?.previewImageUri" />
    <Meta name="twitter:description" :content="article?.shortDescription" />
    <Meta name="twitter:image" :content="article?.previewImageUri" />
    <NewsArticle
      :id="article?.id"
      :title="article?.title"
      :previewImageUri="article?.previewImageUri"
      :publishedAt="article?.publishedAt"
      :hidePreviewImage="article?.hidePreviewImage"
      :type="article?.type"
      :content="article?.content"
    />
  </div>
</template>

<script setup lang="ts">
  definePageMeta({
    settings: {
      cover: {
        title: "News",
      },
    },
  });

  const route = useRoute();
  const articleUrl = route.params.articleUrl!.toString();

  const { getNewsArticleBySlug } = useWebsiteContent();
  const { data: article, suspense: articleSuspense } = getNewsArticleBySlug(articleUrl);
  await articleSuspense();
</script>

<style lang="scss">
  .blog-article-page {
  }
</style>
